module.exports = __webpack_public_path__ + "static/img/anota.15a64ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/projects/anota.png
// module id = UnAJ
// module chunks = 0